module.exports = __webpack_public_path__ + "img/a5.560125e4.png";